import { render, staticRenderFns } from "./defaultimageview.vue?vue&type=template&id=1fab12f8&"
import script from "./defaultimageview.vue?vue&type=script&lang=js&"
export * from "./defaultimageview.vue?vue&type=script&lang=js&"
import style0 from "./defaultimageview.vue?vue&type=style&index=0&id=1fab12f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports